module.exports = __webpack_public_path__ + "img/4.56148e3b.jpg";